module.exports = __webpack_public_path__ + "imgs/9aea93f1c3cb18404b9c44ba0aa36bde.jpg";